var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 947,
    height: 520,
    transform: "translate(-805 -103)",
    fill: "#F7F8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 14.4C15.0643 16.0764 13.7176 17.4168 12 18M12.0001 21.6C8.03005 21.6 4.80005 18.5579 4.80005 14.8187C4.80005 9.59999 12.0002 2.39999 12.0002 2.39999C12.0002 2.39999 19.2 9.59999 19.2 14.8187C19.2 18.558 15.9702 21.6 12.0001 21.6Z",
    stroke: "#4D5E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.316d38c595f7bb9e5e82cd56d078cf1a.svg";
export { ForwardRef as ReactComponent };